<template>
<ims-modal :active="active" :title="$t('case-information-title')" @close="$emit('update:active', false)">
  <div class="case-information-content">
    <b-loading :is-full-page="false" :active="loading" />

    <template v-if="!loading">
      <em v-if="error">{{$t('error-fetch-properties')}}</em>
      <table v-else class="table is-fullwidth">
        <tbody>
          <template v-for="section in caseInformation.sections">
            <tr :key="section.titleKey" class="section-row">
              <td colspan="2">
                <strong>{{ $t(section.titleKey) }}</strong>
              </td>
            </tr>
            <tr v-for="field in section.fields" :key="`${section.titleKey}-${field.labelKey}`">
              <td class="label-cell">{{ $t(field.labelKey) }}</td>
              <td>{{ field.value || '-' }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </template>
  </div>
  <template #footer>
    <button class="button" type="button" @click="$emit('update:active', false)">
      {{$t('button-close')}}
    </button>
  </template>
</ims-modal>
</template>

<script>
import {PropertyCollection} from '@/api';
import ImsModal from '@/components/utils/ImsModal';
import {buildCaseInformationModel} from '@/utils/case-information';

export default {
  name: 'case-information-modal',
  components: {
    ImsModal
  },
  props: {
    active: Boolean,
    image: Object,
  },
  data() {
    return {
      loading: false,
      error: false,
      caseInformation: buildCaseInformationModel([])
    };
  },
  watch: {
    active(newValue) {
      if (newValue) {
        this.fetchCaseInformation();
      }
    }
  },
  methods: {
    async fetchCaseInformation() {
      this.loading = true;
      this.error = false;
      try {
        let props = (await PropertyCollection.fetchAll({object: this.image})).array;
        this.caseInformation = buildCaseInformationModel(props);
      } catch (error) {
        console.log(error);
        this.error = true;
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.case-information-content {
  width: 100%;
  max-width: 100%;
}

.case-information-content .table {
  margin-bottom: 0;
}

.label-cell {
  width: 16em;
}

.section-row td {
  padding-top: 1em;
}

>>> .modal-card {
  width: 900px;
  max-width: calc(100vw - 40px);
}
</style>
